import React, { useEffect, useState } from "react";
import { getAllPrivacyPolicyAndTermandCondition } from "../../hooks/services/api-services";
import { LoaderSpinner, toastEmitter } from "../../utils/utilities";
import { API_RESPONSE } from "../../utils/app-constants";
import { FRAMEIMG, NOAVAILABILITYADDED, } from "../../utils/aap-image-constant";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
const PrivacyAndPolicy = () => {
  const [pending, setPending] = useState(false);
  const [privacyData, setPrivacyData] = useState([]);
  const { i18n, t } = useTranslation();
  const fetchAllPrivacyAndPolicy = async () => {
    setPending(true);
    try {
      const response = await getAllPrivacyPolicyAndTermandCondition("Privacy and Policy");
      if (response?.data?.status === 200) {
        setPrivacyData(response?.data?.data || []);
        setPending(false);
      } else {
        setPrivacyData([])
        setPending(false);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      setPending(false);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    fetchAllPrivacyAndPolicy();
  }, []);


  return (
    <div className="container">
      <div className="pt-4 text-center">
        <div className="">
          <img src={FRAMEIMG} alt="Icon" className="mb-2" />
          <h2 className="mb-1">{t("privacyPolicy")}</h2>
          <p className="mb-0">{t("weAreHereToHelp")}</p>
        </div>
      </div>

      {pending ? <LoaderSpinner /> :
        <div className="py-4">
          {privacyData ? (
            <div><p> {parse(`${i18n.language === "en" ? privacyData?.englishContent : i18n.language === "ar" ? privacyData?.arabicContent : privacyData?.franchContent}`)}</p></div>

          ) : (
            <div className="text-center">
              <img
                src={NOAVAILABILITYADDED}
                alt="No Data Found"
                className="img-fluid"
              />
              <p className="fw-600 fs-16">{t("No Privacy Policy Found")}</p>
            </div>
          )}

        </div>
      }
    </div>
  );
};

export default PrivacyAndPolicy;
